"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CheckboxInput = function CheckboxInput(props) {
  var field = props.field,
    label = props.label,
    tooltip = props.tooltip;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "form-check-input",
    type: "checkbox"
  }, field, {
    checked: field.value || false
  })), " ", label, tooltip && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      cursor: 'default',
      marginLeft: '0.25rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))));
};
CheckboxInput.propTypes = {
  field: _propTypes["default"].object,
  label: _propTypes["default"].node,
  tooltip: _propTypes["default"].node
};
var _default = exports["default"] = CheckboxInput;